import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';

import { DIALOG_DATA, DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { AvatarComponent, ButtonComponent } from '@iw/common';
import { AuthService } from '@iw/core/auth-store';
import { UserGoogleProfile } from '@iw/core/entities';
import {
  IwDialogService,
  ProfileService,
  ThemeService,
} from '@iw/core/services';

import { OrdersHistoryComponent } from '../../../orders-history';

@Component({
  selector: 'iw-user-menu-dialog',
  imports: [AvatarComponent, IconModule, ButtonComponent, TranslateModule],
  templateUrl: './user-menu-dialog.component.html',
  styleUrl: './user-menu-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuDialogComponent {
  readonly #dialogService = inject(IwDialogService);
  readonly #authService = inject(AuthService);
  readonly #profileService = inject(ProfileService);

  #isLoggingOut = false;

  readonly themeService = inject(ThemeService);
  readonly dialogRef = inject(DialogRef);
  readonly dialogData = inject<{ data?: { userProfile?: UserGoogleProfile } }>(
    DIALOG_DATA,
  );

  readonly userProfile = computed(
    () => this.dialogData.data?.userProfile ?? null,
  );

  readonly supportLink = 'https://t.me/iii_wallet_support_bot';

  get activeProfile() {
    return this.#profileService.activeProfile();
  }

  setTheme(theme: 'light' | 'dark'): void {
    this.themeService.setTheme(theme);
  }

  openOrdersHistory(): void {
    this.dialogRef.close();
    this.#dialogService.open<OrdersHistoryComponent, void>({
      components: [OrdersHistoryComponent],
      fullWidth: true,
      fullScreen: true,
    });
  }

  logout(): void {
    if (this.#isLoggingOut) {
      return;
    }
    this.#isLoggingOut = true;
    this.#authService.logout();
    this.dialogRef.close();
  }
}
